import Bugsnag from '@bugsnag/js';
import { dehydrate } from '@tanstack/react-query';
import type { GetServerSideProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import React from 'react';

import { BannerSlot } from '@/core/lib/ads/ads.context';
import Query from '@/core/lib/new-architecture/query';
import makeQueryClient from '@/core/lib/query/queryClient';
import base from '@/core/lib/translation/base';
import Catalogue from '@/core/pages/Catalogue';
import { donationsPublicDonationQuerySchema } from '@/core/types/donation';
import PublicLayout from '@/next/layouts/PublicLayout';

export const getServerSideProps: GetServerSideProps = async context => {
  try {
    const data = donationsPublicDonationQuerySchema.cast(context.query, { stripUnknown: true, assert: false });
    const queryClient = makeQueryClient();

    await Promise.all([
      await Query.categories.useCategories.prefetch?.({ queryClient }),
      await Query.locs.useDetail.prefetch?.({ queryClient, search: data.loc }),
      await Query.donations.useDonations.prefetch?.({ queryClient, ...data }),
    ]);

    const dehydratedState = dehydrate(queryClient);

    return {
      props: {
        ...(await serverSideTranslations('fr', [...base, 'catalogue'])),
        path: `/catalogue/ville/${context.query.loc}`,
        dehydratedState,
      },
    };
  } catch (err) {
    Bugsnag.notify(err as Error);

    return {
      props: {
        ...(await serverSideTranslations('fr', [...base, 'catalogue'])),
        path: `/catalogue/ville/${context.query.loc}`,
      },
    };
  }
};

Catalogue.getLayouts = page => {
  return <PublicLayout adSlot={BannerSlot.DONNONS_LIST_SIDE}>{page}</PublicLayout>;
};

Catalogue.footer = { catalogue: true };

export default Catalogue;
